import React from 'react';
import Attachment from "../../../../model2/attachment/attachment";
import {FieldGlistViewProps} from "../../../render/glist/glist-view";
import AttachmentPill from "../../../../gd-components/files/attachment-pill/attachment-pill";

type State = {
    showPopover: boolean
    isHovered  : boolean
}

export default class FieldAttachment_GListView extends React.Component<FieldGlistViewProps, State>{

   constructor(props: FieldGlistViewProps) {
       super(props);

       this.state = {
           showPopover: false,
           isHovered  : false
       }
   }

    onClick = () => {
        const attachments: Attachment[] = this.props.model[this.props.field.fieldId]

        if(!!attachments){
            this.setState({
                showPopover     : !this.state.showPopover
            })
        }
    }

    hidePopover = ()=>{
        this.setState({
            showPopover     : false,
            isHovered       : false
        })
    }

    onMouseEnter = () => {
        if (!this.state.isHovered) this.setState({
            isHovered   : true
        })
    }

    onMouseLeave = () => {
        if (this.state.showPopover) return
        if (this.state.isHovered) this.setState({
            isHovered   : false
        })
    }

    get classes():string {
        const classes = Classes("ui5-field-editable",
                                            "w-100-percent",
                                            "size-default")
        return classes
    }

    renderValue() {
        const attachments: Attachment[] = this.props.model[this.props.field.fieldId]

        if (!attachments) return <div className={Classes("flex-row-left-center", "w-100-percent", "txt-truncate")}></div>

        const availableWidth:number = this.props.module.columns.get(this.props.field.fieldId).width - 20 - 55; // 20px padding

        const itemsToShow   = Math.floor((availableWidth) / 150)

        const shownItems    = _.slice(attachments, 0 , itemsToShow)
        const hiddenItems   = _.slice(attachments, itemsToShow, attachments.length)

        return (
            <div className={Classes("flex-row-left-center", "w-100-percent", "txt-truncate")}>
                <div className="flex-row-left-center w-100-percent txt-truncate cursor-default">
                    {shownItems.map((attachment: Attachment, key)=>{
                        return (<AttachmentPill key={key} attachment={attachment}/>)
                    })}
                    {(hiddenItems?.length >= 1 && (!this.state.isHovered || shownItems.length === 0 )) && (
                        <div className="ui5-counter dark">+{hiddenItems?.length}</div>
                    )}
                </div>
            </div>
        )
    }

    renderHovered() {
        const {field} = this.props;
        const attachments: Attachment[] = this.props.model[this.props.field.fieldId]
        const classes = Classes(this.classes, {
            "is-hovered": !!attachments
        })

        return (
            <React.Fragment>
                <div className={classes} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}
                     onClick={this.onClick}>
                    {this.renderValue()}

                    {!!attachments && (
                        <div className="buttons flex-no-shrink">
                            <div className="btn-arrow"/>
                        </div>
                    )}

                    {this.state.showPopover &&
                        <field.components.PopoverMenu parent={this} field={this.props.field} model={this.props.model}/>
                   }
               </div>
           </React.Fragment>
        )
    }

    renderNotHovered() {
        return (
            <React.Fragment>
                <div className={this.classes} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                    {this.renderValue()}
                </div>
            </React.Fragment>
        )
    }

    render() {

       if (this.state.isHovered) return this.renderHovered()

        return this.renderNotHovered()
    }
}
